import { Box, styled } from "@mui/material";

import { Typography } from "components/Typography";

import { DATA_SOURCE_TYPES, DATA_SOURCE_OPTIONS } from "./SourceFilter";

const Wrapper = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
}));

const LegendBox = styled(Box)(() => ({
  width: "30px",
  height: "20px",
}));

export const DATA_SOURCE_COLOR = {
  [DATA_SOURCE_TYPES.bank]: "#2D75B6",
  [DATA_SOURCE_TYPES.business]: "#FF9966",
};

export const DashboardChartLegend = () => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-evenly",
        columnGap: "20px",
      }}
    >
      <Wrapper sx={{ columnGap: "8px" }}>
        <LegendBox
          sx={{ backgroundColor: DATA_SOURCE_COLOR[DATA_SOURCE_TYPES.bank] }}
        />
        <Typography>{DATA_SOURCE_OPTIONS[DATA_SOURCE_TYPES.bank]}</Typography>
      </Wrapper>
      <Wrapper sx={{ columnGap: "8px" }}>
        <LegendBox
          sx={{
            backgroundColor: DATA_SOURCE_COLOR[DATA_SOURCE_TYPES.business],
          }}
        />
        <Typography>
          {DATA_SOURCE_OPTIONS[DATA_SOURCE_TYPES.business]}
        </Typography>
      </Wrapper>
    </Box>
  );
};
